import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './Accordion.scss';

export const AccordionCollapsible = (props) => {
  const { id, children, isActive, extendClass = '' } = props;
  const openClass = isActive ? 'active' : '';
  const classes = `panel-collapsible ${openClass} ${extendClass}`;
  const collapseDiv = useRef();

  const setPanelMaxHeight = () => (isActive ? collapseDiv.current.scrollHeight : 0);

  useEffect(() => {
    const panelMaxHeight = setPanelMaxHeight();
    collapseDiv.current.style.maxHeight = `${panelMaxHeight}px`;
  }, [children, isActive]);

  return (
    <div id={id} className={classes} ref={collapseDiv}>
      {children}
    </div>
  );
};

AccordionCollapsible.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  isActive: PropTypes.bool,
  extendClass: PropTypes.string,
};
